import accountModel from './account'
import aliyunModel from './aliyun'
import reportModel from './report'
import storeModel from './store'
import bankModel from './bank'
import clazzModel from './clazz'
import catalogModel from './catalog'
import contactModel from './contact'
import frameModel from './frame'
import purchaseModel from './purchase'
import paperModel from './paper'
import examModel from './exam'

export {
    accountModel,
    aliyunModel,
    reportModel,
    storeModel,
    bankModel,
    clazzModel,
    catalogModel,
    contactModel,
    frameModel,
    purchaseModel,
    paperModel,
    examModel
}



// WEBPACK FOOTER //
// ./bootsets/models/index.js